import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { AzureDevOpsWorkItem } from 'pages/azure-devops/WorkItem';
import { AzureDevOps } from 'pages/azure-devops/AzureDevOps';
import { RunsByProject } from 'pages/testrail/RunsByProject';
import { BrowseCases } from 'pages/testrail/BrowseCases';
import { CaseDetail } from 'pages/testrail/CaseDetail';
import { CreateCase } from 'pages/testrail/CreateCase';
import { AdminSettings } from 'pages/admin/Settings';
import { RunDetail } from 'pages/testrail/RunDetail';
import { OpenRuns } from 'pages/testrail/OpenRuns';
import { AdminUsers } from 'pages/admin/Users';
import { AdminApps } from 'pages/admin/Apps';
import { AppLayout } from 'common/AppLayout';
import { Runner } from 'pages/runner/Runner';
import { Usage } from 'pages/usage/Usage';
import { AuthCallback } from 'pages/auth';
import { Home } from 'pages/home/Home';

export const AppRouter = () => (

    <Router>
        <Switch>

            <Route exact component={AuthCallback} path="/authenticate/callback" />

            <Route>
                <AppLayout>
                    <Switch>

                        <Route exact component={Home} path="/" />
                        <Route component={Runner} path="/feature-tester" />
                        <Route exact component={AzureDevOps} path="/azure-devops" />
                        <Route component={AzureDevOpsWorkItem} path="/azure-devops/:id" />
                        <Route exact component={OpenRuns} path="/testrail/runs" />
                        <Route component={RunsByProject} path="/testrail/runs/projects/:projectId" />
                        <Route component={RunDetail} path="/testrail/runs/:id" />
                        <Route exact component={BrowseCases} path="/testrail/cases" />
                        <Route exact component={CreateCase} path="/testrail/cases/new" />
                        <Route component={CaseDetail} path="/testrail/cases/:id" />
                        <Route component={Usage} path="/usage" />
                        <Route component={AdminUsers} path="/admin/users" />
                        <Route component={AdminApps} path="/admin/apps" />
                        <Route component={AdminSettings} path="/admin/settings" />

                    </Switch>
                </AppLayout>
            </Route>

        </Switch>
    </Router>

);
